import { Injectable, inject } from '@angular/core';
import { ANALYTICS_STRATEGIES } from './analytics.tokens';

@Injectable({ providedIn: 'root' })
export class AnalyticsService {
  readonly #strategies = inject(ANALYTICS_STRATEGIES);

  trackEvent(event: string, params?: Record<string, unknown>) {
    this.#strategies.forEach((strategy) => strategy.trackEvent(event, params));
  }

  trackPage(url: string) {
    this.#strategies.forEach((strategy) => strategy.trackPage(url));
  }
}
